/**
 * R8-P0-1/NEW-P1-1 fix (round 8, live-Chrome critic): "Play now" from the Library screen
 * (`App.tsx`'s ad-hoc `handlePlayNow`) never actually started playback — confirmed live: the song
 * loaded (server `isPlaying:true` was never even reached; the patch itself deliberately stays
 * `isPlaying:false` per `cuedSongPatch`'s own doc comment) and nothing ever called `togglePlay()`.
 * `OperatorConsole.tsx`'s rotation "Play now"/"Start next" buttons worked because `advance()` sets
 * a same-component `pendingAutoPlayRef`, watched by an effect that calls `engine.togglePlay()` the
 * moment the cued song is actually the one loaded — but `App.tsx`'s `ConsoleShell` and
 * `OperatorConsole` are different components (and `OperatorConsole`'s host, per the "always
 * mounted, hidden on Library" fix in `App.tsx`, may currently be invisible), so that ref could
 * never be reached from the Library tab.
 *
 * A module-level singleton (not a React ref/context — there is no shared component tree between
 * `ConsoleShell` and the internals of a lazy-loaded `OperatorConsole`) both sides import: `App.tsx`
 * writes the song it just cued, `OperatorConsole.tsx`'s existing pending-autoplay effect reads it
 * exactly the way it already reads its own local ref for the queue-driven case. One flag, one
 * consumer, matches the "route through one place" instruction for this fix.
 */
export const pendingAutoplaySongIdRef: { current: string | null } = { current: null };
